export default "__VITE_ASSET__DLyhvtR9__"